/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import urls from "../../api/urls";
import NormalAPI from "../../api";

const {
  GET_HUBOPS_DATA,
  GET_DIRECTOR_DASHBOARD_HUBOPS_SUMMARY,
  GET_DIRECTOR_DASHBOARD_HUBOPS_ZONE_WISE_BREAKDOWN,
  GET_DIRECTOR_DASHBOARD_BOOKING_SUMMARY,
  GET_DIRECTOR_DASHBOARD_BOOKING_ZONE_WISE_BREAKDOWN,
  GET_DIRECTOR_DASHBOARD_DELIVERY_SUMMARY,
  GET_DIRECTOR_DASHBOARD_DELIVERY_ZONE_WISE_BREAKDOWN,
  GET_SHIPMENT_BUSINESS_DATA,
  GET_DELIVERY_DATA,
  GET_BUSINESS_STATISTICS_PREVIOUS_DAY,
  GET_BUSINESS_STATISTICS_CURRENT_MONTH,
  GET_ZONE_WISE_DATA,
  GET_ZONE_HUB_CP_DATA,
  REFRESH_CACHE_HUBOPS_DATA,
  REFRESH_CACHE_BUSINESS_STATISTICS_PREVIOUS_DAY,
  REFRESH_CACHE_BUSINESS_STATISTICS_CURRENT_MONTH,
  GET_BUSINESS_STATISTICS_SUMMARY,
} = urls;

export const DirectorDashboardService3 = {
  /**
   * Fetch HubOps summary for Director Dashboard KPI cards
   * @param {string} fromDate - Start date in YYYY-MM-DD format
   * @param {string} toDate - End date in YYYY-MM-DD format
   * @param {Object} [options] - Additional options (e.g., signal for AbortController)
   * @returns {Promise<Object>} Response data containing hub operations metrics
   */
  getHubOpsData: async (fromDate, toDate, options = {}) => {
    try {
      const queryString = new URLSearchParams({ fromDate, toDate }).toString();
      const url = `${GET_DIRECTOR_DASHBOARD_HUBOPS_SUMMARY}?${queryString}`;
      const response = await NormalAPI.Api(url).getCustomHeader(options);

      if (response?.status && response?.response?.status === 200) {
        return {
          data: response?.response?.data || {},
          message: response?.response?.data?.status || "Success",
        };
      }
      throw new Error(response?.response?.data?.message || "Failed to fetch HubOps data");
    } catch (error) {
      console.error("Error fetching HubOps data:", error);
      throw error;
    }
  },


  getZoneWiseBreakdown: async (fromDate, toDate, options = {}) => {
    try {
      const queryString = new URLSearchParams({ fromDate, toDate }).toString();
      const url = `${GET_DIRECTOR_DASHBOARD_HUBOPS_ZONE_WISE_BREAKDOWN}?${queryString}`;
      const response = await NormalAPI.Api(url).getCustomHeader(options);

      if (response?.status && response?.response?.status === 200) {
        return {
          data: response?.response?.data || {},
          message: response?.response?.data?.status || "Success",
        };
      }
      throw new Error(response?.response?.data?.message || "Failed to fetch zone-wise breakdown");
    } catch (error) {
      console.error("Error fetching zone-wise breakdown:", error);
      throw error;
    }
  },


  getBookingSummary: async (fromDate, toDate, options = {}) => {
    try {
      const queryString = new URLSearchParams({ fromDate, toDate }).toString();
      const url = `${GET_DIRECTOR_DASHBOARD_BOOKING_SUMMARY}?${queryString}`;
      const response = await NormalAPI.Api(url).getCustomHeader(options);

      if (response?.status && response?.response?.status === 200) {
        return {
          data: response?.response?.data || {},
          message: response?.response?.data?.status || "Success",
        };
      }
      throw new Error(response?.response?.data?.message || "Failed to fetch booking summary");
    } catch (error) {
      console.error("Error fetching booking summary:", error);
      throw error;
    }
  },


  getBookingZoneWiseBreakdown: async (fromDate, toDate, options = {}) => {
    try {
      const queryString = new URLSearchParams({ fromDate, toDate }).toString();
      const url = `${GET_DIRECTOR_DASHBOARD_BOOKING_ZONE_WISE_BREAKDOWN}?${queryString}`;
      const response = await NormalAPI.Api(url).getCustomHeader(options);

      if (response?.status && response?.response?.status === 200) {
        return {
          data: response?.response?.data || {},
          message: response?.response?.data?.status || "Success",
        };
      }
      throw new Error(response?.response?.data?.message || "Failed to fetch booking zone-wise breakdown");
    } catch (error) {
      console.error("Error fetching booking zone-wise breakdown:", error);
      throw error;
    }
  },


  getDeliverySummary: async (fromDate, toDate, options = {}) => {
    try {
      const queryString = new URLSearchParams({ fromDate, toDate }).toString();
      const url = `${GET_DIRECTOR_DASHBOARD_DELIVERY_SUMMARY}?${queryString}`;
      const response = await NormalAPI.Api(url).getCustomHeader(options);

      if (response?.status && response?.response?.status === 200) {
        return {
          data: response?.response?.data || {},
          message: response?.response?.data?.status || "Success",
        };
      }
      throw new Error(response?.response?.data?.message || "Failed to fetch delivery summary");
    } catch (error) {
      console.error("Error fetching delivery summary:", error);
      throw error;
    }
  },

  /**
   * Fetch zone-wise delivery breakdown for Director Dashboard
   * @param {string} fromDate - Start date in YYYY-MM-DD format
   * @param {string} toDate - End date in YYYY-MM-DD format
   * @param {Object} [options] - Additional options (e.g., signal for AbortController)
   * @returns {Promise<Object>} Response data containing zone-wise delivery metrics
   */
  getDeliveryZoneWiseBreakdown: async (fromDate, toDate, options = {}) => {
    try {
      const queryString = new URLSearchParams({ fromDate, toDate }).toString();
      const url = `${GET_DIRECTOR_DASHBOARD_DELIVERY_ZONE_WISE_BREAKDOWN}?${queryString}`;
      const response = await NormalAPI.Api(url).getCustomHeader(options);

      if (response?.status && response?.response?.status === 200) {
        return {
          data: response?.response?.data || {},
          message: response?.response?.data?.status || "Success",
        };
      }
      throw new Error(response?.response?.data?.message || "Failed to fetch delivery zone-wise breakdown");
    } catch (error) {
      console.error("Error fetching delivery zone-wise breakdown:", error);
      throw error;
    }
  },

  /**
   * Fetch Business Statistics Previous Day Data for Director Dashboard
   * @param {Object} [options] - Additional options (e.g., signal for AbortController)
   * @returns {Promise<Object>} Response data containing business, shipment, and delivery data
   */
  getBusinessStatisticsPreviousDay: async (options = {}) => {
    try {
      const response = await NormalAPI.Api(GET_BUSINESS_STATISTICS_PREVIOUS_DAY).post({}, options);


      if (response?.status && response?.response?.status === 200) {
        return {
          data: response?.response?.data || {},
          message: response?.response?.data?.status || "Success",
        };
      }
      throw new Error(response?.response?.data?.message || "Failed to fetch Business Statistics Previous Day Data");
    } catch (error) {
      console.error("Error fetching Business Statistics Previous Day Data:", error);
      throw error;
    }
  },

  /**
   * Fetch Business Statistics Summary for a given date range
   * @param {string} startDate - Start date in YYYY-MM-DD format
   * @param {string} endDate - End date in YYYY-MM-DD format
   * @param {Object} [options] - Additional options (e.g., signal for AbortController)
   * @returns {Promise<Object>} Response data
   */
  getBusinessStatsSummary: async (startDate, endDate, options = {}) => {
    try {
      const queryString = new URLSearchParams({ startDate, endDate }).toString();
      const url = `${GET_BUSINESS_STATISTICS_SUMMARY}?${queryString}`;
      const response = await NormalAPI.Api(url).getCustomHeader(options);

      if (response?.status && response?.response?.status === 200) {
        return {
          data: response?.response?.data || {},
          message: response?.response?.data?.status || "Success",
        };
      }
      throw new Error(response?.response?.data?.message || "Failed to fetch Business Statistics Summary");
    } catch (error) {
      console.error("Error fetching Business Statistics Summary:", error);
      throw error;
    }
  },

  /**
   * Fetch Business Statistics Current Month Data for Director Dashboard
   * @param {Object} [options] - Additional options (e.g., signal for AbortController)
   * @returns {Promise<Object>} Response data containing business, shipment, and delivery data for current month
   */
  getBusinessStatisticsCurrentMonth: async (options = {}) => {
    try {
      const response = await NormalAPI.Api(GET_BUSINESS_STATISTICS_CURRENT_MONTH).post({}, options);


      if (response?.status && response?.response?.status === 200) {
        console.log("Business Statistics Current Month Response:", response?.response?.data);
        return {
          data: response?.response?.data || {},
          message: response?.response?.data?.status || "Success",
        };
      }
      throw new Error(response?.response?.data?.message || "Failed to fetch Business Statistics Current Month Data");
    } catch (error) {
      console.error("Error fetching Business Statistics Current Month Data:", error);
      throw error;
    }
  },

  /**
   * Fetch Zone Wise Data for Director Dashboard
   * @param {string} fromDate - Start date in YYYY-MM-DD format
   * @param {string} toDate - End date in YYYY-MM-DD format
   * @param {Object} [options] - Additional options (e.g., signal for AbortController)
   * @returns {Promise<Object>} Response data containing zone-wise business, shipment, and delivery data
   */
  getZoneWiseData: async (fromDate, toDate, options = {}) => {
    try {
      const queryParams = {
        fromDate,
        toDate,
      };
      const queryString = new URLSearchParams(queryParams).toString();
      const url = `${GET_ZONE_WISE_DATA}?${queryString}`;

      const response = await NormalAPI.Api(url).getCustomHeader(options);

      if (response?.status && response?.response?.status === 200) {
        console.log("Zone Wise Data Response:", response?.response?.data);
        return {
          data: response?.response?.data || {},
          message: response?.response?.data?.status || "Success",
        };
      }
      throw new Error(response?.response?.data?.message || "Failed to fetch Zone Wise Data");
    } catch (error) {
      console.error("Error fetching Zone Wise Data:", error);
      throw error;
    }
  },

  /**
   * Fetch Zone Hub CP Data for ZoneList, HubWiseView, and CPWiseView
   * @param {string} figureType - Type: "business", "shipment_count", or "drs"
   * @param {string} figureSubtype - Subtype: "Account", "Cash", "DP", "Piece", "Total DRS", "Delivered", etc.
   * @param {string} fromDate - Start date in YYYY-MM-DD format
   * @param {string} toDate - End date in YYYY-MM-DD format
   * @param {string} [zoneId] - Optional zone ID (required for HubWiseView and CPWiseView)
   * @param {string} [hubId] - Optional hub ID (required for CPWiseView)
   * @param {Object} [options] - Additional options (e.g., signal for AbortController)
   * @returns {Promise<Object>} Response data containing zoneWiseSummary, hubWiseSummary, or cpWiseSummary
   */
  getZoneHubCpData: async (figureType, figureSubtype, fromDate, toDate, zoneId = null, hubId = null, options = {}) => {
    try {
      const queryParams = {
        figureType,
        figureSubtype,
        fromDate,
        toDate,
      };

      if (zoneId) {
        queryParams.zoneId = zoneId;
      }
      if (hubId) {
        queryParams.hubId = hubId;
      }

      const queryString = new URLSearchParams(queryParams).toString();
      const url = `${GET_ZONE_HUB_CP_DATA}?${queryString}`;

      const response = await NormalAPI.Api(url).getCustomHeader(options);

      if (response?.status && response?.response?.status === 200) {
        console.log("Zone Hub CP Data Response:", response?.response?.data);
        return {
          data: response?.response?.data || {},
          message: response?.response?.data?.status || "Success",
        };
      }
      throw new Error(response?.response?.data?.message || "Failed to fetch Zone Hub CP Data");
    } catch (error) {
      console.error("Error fetching Zone Hub CP Data:", error);
      throw error;
    }
  },

  /**
   * Refresh cache for HubOps data
   * @param {Object} [options] - Additional options (e.g., signal for AbortController)
   * @returns {Promise<Object>} Response data indicating cache refresh status
   */
  refreshCacheHubOpsData: async (options = {}) => {
    try {
      const response = await NormalAPI.Api(REFRESH_CACHE_HUBOPS_DATA).get(options);


      if (response?.status && response?.response?.status === 200) {
        return {
          data: response?.response?.data || {},
          message: response?.response?.data?.message || response?.response?.data?.status || "Cache refreshed successfully",
        };
      }
      throw new Error(response?.response?.data?.message || "Failed to refresh cache");
    } catch (error) {
      console.error("Error refreshing cache:", error);
      throw error;
    }
  },

  /**
   * Refresh cache for Business Statistics Previous Day data
   * @param {Object} [options] - Additional options (e.g., signal for AbortController)
   * @returns {Promise<Object>} Response data containing business, shipment, and delivery data
   */
  refreshCacheBusinessStatisticsPreviousDay: async (options = {}) => {
    try {
      const response = await NormalAPI.Api(REFRESH_CACHE_BUSINESS_STATISTICS_PREVIOUS_DAY).get(options);


      if (response?.status && response?.response?.status === 200) {
        return {
          data: response?.response?.data || {},
          message: response?.response?.data?.message || response?.response?.data?.status || "Cache refreshed successfully",
        };
      }
      throw new Error(response?.response?.data?.message || "Failed to refresh cache");
    } catch (error) {
      console.error("Error refreshing cache:", error);
      throw error;
    }
  },

  /**
   * Refresh cache for Business Statistics Current Month data
   * @param {Object} [options] - Additional options (e.g., signal for AbortController)
   * @returns {Promise<Object>} Response data indicating cache refresh status
   */
  refreshCacheBusinessStatisticsCurrentMonth: async (options = {}) => {
    try {
      const response = await NormalAPI.Api(REFRESH_CACHE_BUSINESS_STATISTICS_CURRENT_MONTH).get(options);


      if (response?.status && response?.response?.status === 200) {
        return {
          data: response?.response?.data || {},
          message: response?.response?.data?.message || response?.response?.data?.status || "Cache refreshed successfully",
        };
      }
      throw new Error(response?.response?.data?.message || "Failed to refresh cache");
    } catch (error) {
      console.error("Error refreshing cache:", error);
      throw error;
    }
  },
};

